import { render, staticRenderFns } from "./StockErrAdd.vue?vue&type=template&id=253aa614&scoped=true&"
import script from "./StockErrAdd.vue?vue&type=script&lang=js&"
export * from "./StockErrAdd.vue?vue&type=script&lang=js&"
import style0 from "./StockErrAdd.vue?vue&type=style&index=0&id=253aa614&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253aa614",
  null
  
)

export default component.exports